import posthog from 'posthog-js';
import { TrackerCustomEvent } from '../tracker';
import { EVENT_MAPPING } from '../tracker/eventMapping';
import dayjs from 'dayjs';

type LogType = 'robot-event-log';

const useTracker = () => {
  /**
   * 统一的事件上报方法
   * @param eventType 事件类型
   * @param params 事件参数对象
   */
  const sendEvent = (
    eventType: TrackerCustomEvent,
    params: {
      et?: any;
      c1?: any;
      c2?: any;
      c3?: any;
      c4?: any;
      c5?: any;
      c6?: any;
      c7?: any;
      c8?: any;
      c9?: any;
      c10?: any;
    }
  ) => {
    const mapping = EVENT_MAPPING[eventType];
    if (!mapping) {
      console.error(`未配置的事件类型: ${eventType}`);
      return;
    }
    const action = params?.et || mapping?.action || 'CLK';
    const paramsMapper = (params && mapping?.paramsMapper && mapping?.paramsMapper(params)) || {};
    try {
      if (posthog && posthog.__loaded) {
        posthog.capture(mapping.eventName, {
          action,
          ...paramsMapper,
        });
      }
      // 在sendEvent中调用
    } catch (error) {
      console.error('埋点上报失败:', error);
    }
  };

  const recordLog = (logType: LogType, logParams: { [key: string]: any }) => {
    if (posthog && posthog.__loaded) {
      const resTime = dayjs().format('MM-DD HH:mm:ss');
      //@ts-ignore
      posthog.sessionRecording?.log({
        type: logType,
        time: resTime,
        data: logParams,
      });
    }
  };
  return { sendEvent, recordLog };
};
export default useTracker;
